exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sc-page-mode-setting .Layout-managerContent,.sc-page-mode-setting .Layout-managerContent .sc-page{background:#fff}.setting-mode-inner-wrapper{padding-left:64px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/common/PageLayout/Setting/index.scss
// module id = 1019
// module chunks = 0